module.exports = {render:function anonymous(
) {
with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-labelledby":"trash--s","viewBox":"0 0 15 15"}},[_c('title',[_v("trash--s")]),_c('path',{attrs:{"d":"M12 14H3V5H2v10h11V5h-1v9zM10 1H5v1h5V1zM9 3H1v1h13V3H9zm0 3v6h1V6H9zM5 6v6h1V6H5z"}})])}
}};